<div class="help-pane">
  <div class="help-header">
    <div class="title-group">
      <mat-icon>smart_toy</mat-icon>
      <span>AI Assistent</span>
    </div>
    <button mat-icon-button (click)="close.emit()" aria-label="Sluiten">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="help-content">
    @if (agentKeySetupError()) {
      <div class="setup-error" role="alert">
        De AI assistent is niet beschikbaar. De agent key is niet correct ingesteld.
      </div>
    } @else {
      <iframe title="AI Assistent chat" [src]="chatUrl()" width="100%" height="100%" frameborder="0"></iframe>
    }
  </div>
</div>
